export default "__VITE_ASSET__COF791jf__"